export default __webpack_public_path__ + "static/media/char_head_prem_006.3284d085.png";